<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>绩效工资表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequestBody.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
        v-if="reportTabName == 'day' || reportTabName == 'area'"
      >
      </el-date-picker>
      <el-date-picker
        v-model="reportRequestBody.selectMonth"
        type="monthrange"
        range-separator="至"
        size="mini"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="selectReportDataMonth"
        value-format="yyyy-MM"
        v-if="reportTabName == 'month'"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择门店"
                 style="width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-select v-model="reportRequestBody.userId" clearable value filterable placeholder="请选择员工"
                 style="width: 200px" size="mini" @change="getUser">
        <el-option
          v-for="user in users"
          :key="user.id"
          :label="user.userName"
          :value="user.id">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;"  @click="loadKpiData(reportTabName)">查询</el-button>
    </div>
    <el-tabs type="border-card" v-model="reportTabName" @tab-click="reportTabNameClick" style="height: 650px">
      <el-tab-pane label="日工资" name="day"></el-tab-pane>
      <el-tab-pane label="月工资" name="month"></el-tab-pane>
      <el-tab-pane label="年工资" name="year"></el-tab-pane>
      <el-tab-pane label="区域工资" name="area" v-if="orgLevel<3"></el-tab-pane>

      <el-table height="550px" :data="kpiDataList" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                show-summary>
        <el-table-column
          align="center"
          prop="reportDate"
          label="日期"
          width="150"
          v-if="reportTabName === 'day'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="reportYearMonth"
          label="月份"
          width="150"
          v-if="reportTabName === 'month'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="reportYear"
          label="年份"
          width="150"
          v-if="reportTabName === 'year'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="areaName"
          label="区域"
          width="150"
          v-if="reportTabName === 'area' && orgLevel == 1"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="shopName"
          label="门店"
          width="150"
          v-if="reportTabName === 'area' && orgLevel == 2"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableTitle"
          align="center"
          :key="item.enName"
          :prop="item.enName"
          width="150"
          :render-header="(h, obj) => renderHeader(h, obj, item.consumptionTypeName)"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="huiyuankachongzhiTc"
          label="会员卡充值"
          width="150"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="huiyuankatuifeiTc"
          label="会员卡退费"
          v-if="selectUserId === ''"
          width="150"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="xiaofeidantuifeihuiyuanTc"
          label="消费单退回会员"
          width="150"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="xiaofeidantuifeixianjinTc"
          label="消费单退回现金"
          width="150"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="heji"
          label="合计"
          width="150"
        >
        </el-table-column>
      </el-table>
    </el-tabs>


    <!-- 二级数据 -->
    <el-dialog
      title="详细数据"
      :visible.sync="towLevelDataDialogVisible"
      width="50%"
      @close="closeTowLevelDataDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="towLevelDataList" fit border stripe="stripe" height="550px" width="100%"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}"
      >
        <el-table-column
          align="center"
          prop="reportDate"
          label="日期"
          width="150"
          v-if="reportTabName =='day'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="reportYearMonth"
          label="月份"
          width="150"
          v-if="reportTabName =='month'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="reportYear"
          label="年份"
          width="150"
          v-if="reportTabName =='year'"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="shopName"
          label="门店"
          width="150"
          v-if="reportTabName =='area' && orgLevel == 2"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in towLevelTitle"
          align="center"
          :key="index"
          :prop="item.enName"
          width="150"
        >
          <template slot="header">
            {{item.cnName}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <span class="showFont">
      合计 = 足科提成 + 次卡提成 + 团购提成 + 按摩提成 + 修复及矫正提成 + 华连生产品提成 + 洁沃产品提成 + 贝尔产品提成 + 会员卡充值提成 - 会员卡退费提成
      - 消费单退费会员提成 - 消费单退费现金提成
    </span>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      orgId:'',
      orgLevel:'',
      authorities:'',
      authName:'',
      groupValue:'',
      performanceDate:'',
      tableTitle:[],
      kpiDataList:[],
      area:[],
      shop:[],
      users:[],
      selectAreaId:'',
      selectOrgId:'',
      selectUserId:'',
      reportTabName:'day',
      reportRequestBody:{
        selectDay:'',
        startDate:'',
        endDate:'',
        selectMonth:'',
        startMonth:'',
        endMonth:'',
        oneLevelHeader:'',
        shopId:0,
        areaId:0,
        orgId:'',
        userId:'',
        orgLevel:'',
        userName:'',
        dataAuth:'',
        authValue:'',
      },
      towLevelDataDialogVisible:false,
      towLevelTitle:[],
      towLevelDataList:[],
      tabName:'day',
      dayTip:false,
      monthTip:false,

    }
  },
  methods:{
    reportTabNameClick(tab, event){
      this.reportTabName = tab.name;
      this.reportRequestBody.selectDay='';
      this.reportRequestBody.selectMonth='';
      // this.reportRequestBody.areaId='';
      this.reportRequestBody.shopId='';
      this.reportRequestBody.orgId='';
      this.reportRequestBody.userId='';
      this.selectAreaId='';
      this.selectOrgId='';
      this.kpiDataList = [];
      this.loadKpiData(tab.name);
    },
    async getArea(data){
      if (data !== ''){
        this.reportRequestBody.areaId = data;
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
        this.shop = res.data;
      } else {
        this.reportRequestBody.areaId = 0;
      }
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopId = data;
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.users = res.data;
      } else {
        this.reportRequestBody.shopId = 0;
      }
    },
    getUser(data){
      if (data !== ''){
        this.reportRequestBody.userId = data;
      } else {
        this.reportRequestBody.userId = 0;
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    async loadTableTitle(){
      let id = 0;
      if (this.reportRequestBody.areaId == 0 && this.reportRequestBody.shopId == 0){
        id = this.orgId;
      }
      if (this.reportRequestBody.areaId > 0){
        id = this.reportRequestBody.areaId;
      }
      if (this.reportRequestBody.shopId > 0){
        id = this.reportRequestBody.shopId;
      }
      const {data:res} = await this.$http.get(`/salary/header/orgId/${id}`)
      this.tableTitle = res.data;
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    loadKpiData(reportTabName){
      this.reportRequestBody.startDate='';
      this.reportRequestBody.endDate='';
      this.reportRequestBody.startMonth='';
      this.reportRequestBody.endMonth='';

      if (reportTabName ==='day'){
        this.loadKpiDataByDay();
      }
      if (reportTabName ==='month'){
        this.loadKpiDataByMonth();
      }
      if (reportTabName ==='year'){
        this.loadKpiDataByYear();
      }
      if (reportTabName ==='area'){
        this.loadKpiDataByArea();
      }
    },
    async loadKpiDataByDay(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      if (this.orgLevel == 2){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/salary/oneLevel/data/day`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByMonth(){
      // this.reportRequestBody.startMonth = this.getCurrentMonth();
      // this.reportRequestBody.endMonth = this.getCurrentMonth();
      if (this.reportRequestBody.selectMonth !== '' && this.reportRequestBody.selectMonth != null){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      if (this.orgLevel == 2){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/salary/oneLevel/data/month`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByArea(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== ''){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      if (this.orgLevel == 2){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/salary/oneLevel/data/area`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByYear(){
      if (this.orgLevel == 2){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/salary/oneLevel/data/year`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    // 自定义表头
    renderHeader(h, { column, $index }, type) {
      let that = this;
      return h(
        'div', [
          // 列名称
          h('span', column.label),
          // 按钮
          h('el-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: 'margin-left: 5px;height:20px;padding-top: 2px;color: #333 ',
            on: {
              click: function () {
                if (type === '足科' || type === '按摩' || type === '团购' || type === '修复及矫正' || type === '华连生产品'
                  || type === '洁沃产品' || type === '贝尔产品'){
                  that.clickButton(type);
                }
              }
            }
          }, type)
        ],
      )
    },
    clickButton(type) {
      this.reportRequestBody.oneLevelHeader = type;
      this.towLevelTitle = [];
      this.loadTowLevelHeader();
      this.loadTowLevelData(this.reportTabName);
      this.showTowLevelDataDialog();
    },
    showTowLevelDataDialog(){
      this.towLevelDataDialogVisible = true;
    },
    closeTowLevelDataDialog(){
      this.towLevelDataDialogVisible = false;
    },
    async loadTowLevelHeader(){
      const {data:res} = await this.$http.post(`/salary/header/two/level`, this.reportRequestBody)
      this.towLevelTitle = res.data;
    },
    async loadTowLevelData(reportTabName){
      if (reportTabName ==='day'){
        this.loadTwoLevelDayData();
      }
      if (reportTabName ==='month'){
        this.loadTwoLevelMonthData();
      }
      if (reportTabName ==='year'){
        this.loadTwoLevelYearData();
      }
      if (reportTabName ==='area'){
        this.loadTwoLevelAreaData();
      }
    },

    async loadTwoLevelDayData(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== ''){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      const {data:res} = await this.$http.post(`/salary/twoLevel/data/day`, this.reportRequestBody)
      this.towLevelDataList = res.data;
    },
    async loadTwoLevelMonthData(){
      this.reportRequestBody.startMonth = this.getCurrentMonth();
      this.reportRequestBody.endMonth = this.getCurrentMonth();
      if (this.reportRequestBody.selectMonth !== ''){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      const {data:res} = await this.$http.post(`/salary/twoLevel/data/month`, this.reportRequestBody)
      this.towLevelDataList = res.data;
    },
    async loadTwoLevelYearData(){
      const {data:res} = await this.$http.post(`/salary/twoLevel/data/year`, this.reportRequestBody)
      this.towLevelDataList = res.data;
    },
    async loadTwoLevelAreaData(){
      const {data:res} = await this.$http.post(`/salary/twoLevel/data/area`, this.reportRequestBody)
      this.towLevelDataList = res.data;
    },
    selectReportDataDay(data){
      if (data == null){
        this.reportRequestBody.selectDay = '';
      } else {
        this.reportRequestBody.selectDay = data;
      }
      // this.reportRequestBody.orgId = this.orgId;
      // this.loadTableTitle();
      // this.loadKpiData(this.reportTabName);
    },
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
      }
      // this.reportRequestBody.orgId = this.orgId;
      // this.loadTableTitle();
      // this.loadKpiData(this.reportTabName);
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    async loadUser(){
      const {data:res} = await this.$http.get(`/org/users/${this.orgId}`);
      this.users = res.data;
    },
    async loadAllUser(){
      const {data:res} = await this.$http.get(`/report/users`);
      this.users = res.data;
    },
    async loadGroupShop(){
      const {data:res} = await this.$http.get(`/group-org`,
        { params:{userId: this.userId, groupValue: this.groupValue}});
      this.shop = res.data;
    },
  },

  created() {
    this.dayTip = true;
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.authName = window.sessionStorage.getItem('authName');
    this.groupValue = window.sessionStorage.getItem('groupValue');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      if(this.authName === 'group'){
        this.loadGroupShop();
      } else {
        this.loadShop();
      }
      this.loadAllUser();
    }
    if (this.orgLevel == 3){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.shopId = this.orgId;
      this.loadUser();
    }
    this.loadTableTitle();
    this.loadKpiData('day');
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
.showFont{
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Salary.vue